<app-service-upload-certificate [serviceId]="serviceId"></app-service-upload-certificate>
